import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { EmpresaLista } from 'src/app/shared/model/tickets/empresaLista.model';
import { TipoSolicitud } from 'src/app/shared/model/tickets/tipoSolicitud.model';
import { TicketMejora } from 'src/app/shared/model/tickets/ticketMejora.model';
import { TicketsService } from '../../tickets.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-mejoras-tickets-edit',
    templateUrl: './mejoras-tickets-edit.component.html',
    styleUrls: ['./mejoras-tickets-edit.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, NgFor, MatOption]
})
export class MejorasTicketsEditComponent {

  mejora: TicketMejora;
  descripcion: String;
  options: FormGroup;
  areas: Area[];
  prioridades: Prioridad[];
  empresas: EmpresaLista[];
  areaSeleccionada: Area;
  areaSeleccionadaRes: Area;
  empresaSeleccionada: EmpresaLista;
  tipoSolicitud: TipoSolicitud[];
  prioridadesFiltradas: Prioridad[];
  nombreEmpresa: String;
  
  constructor(private fb: FormBuilder, public modal: MatDialogRef<MejorasTicketsEditComponent>,
    private ticketsService: TicketsService, @Inject(MAT_DIALOG_DATA) public data: any) { }


    ngOnInit() {
      this.mejora = Object.assign({}, this.data.datos);// estructura para Clonar un objeto
      this.descripcion = Object.assign({}, this.data).desc;

      this.options = this.fb.group({
        //asuntoCtrl: ['', Validators.required],
        nombreCtrl: ['', Validators.required],
        empresaCtrl: ['', Validators.required],
        areaCtrl: ['', Validators.required],
        areaResCtrl: ['', Validators.required],
        fechaSolicitudCtrl: ['', Validators.required],
        prioridadCtrl: ['', Validators.required],
        proyectoCtrl: ['', Validators.required],
        descripcionCtrl: ['', Validators.required],
        justificacionCtrl: ['', Validators.required],
        TipoSolicitudCtrl: ['', Validators.required],
      });

      this.ticketsService.consultarTipoSolicitud().subscribe(resp => {
        if (resp != null) {
          this.tipoSolicitud = resp.list;
        }
      });
  
      this.ticketsService.consultarPrioridad().subscribe(resp => {
        if (resp != null) {
          this.prioridades = resp.list;
          this.prioridadesFiltradas=resp.list;
        }
      });
  
      this.ticketsService.consultarEmpresa(UrlConstantes.consultarEmpresaLista).subscribe(res => {
        if (res != null) {
          for (let i = 0; i < res.list.length; i++) {
          if(res.list[i].id === this.mejora.ticket.id_Empresa){
            this.nombreEmpresa=res.list[i].razon_social;
          }
        }
      }
      });
    }

    salir() {
      this.modal.close();
    }
 
  
    

    
}

